module.exports = __webpack_public_path__ + "Simple-Line-Icons.woff2";


//////////////////
// WEBPACK FOOTER
// ./~/simple-line-icons/fonts/Simple-Line-Icons.woff2?v=2.4.0
// module id = 1245
// module chunks = 8